import { IVacancy } from '../../index';
import { decodeHtml } from '../../utils';
import { EEmployment } from '../../repositories/vacancies/entities/schemas/VacancySchema';
import { IRegion } from '../../types/region';

interface IVacancyFormState {
  specializationIsValid: boolean;
  salaryIsValid: boolean;
  workExperienceIsValid: boolean;
  descriptionIsValid: boolean;
  contactsIsValid: boolean;
  recaptchaIsValid: boolean;
  specialization: string;
  minSalary?: number;
  maxSalary?: number;
  region: IRegion;
  byAgreementSalary: boolean;
  workExperience?: number;
  noWorkExperience: boolean;
  employment: EEmployment;
  description: string;
  contactPhone: string;
  contactEmail: string;
  cancelAddVacancyModalOpened: boolean;
  recaptcha: string;
  formIsFilled: boolean;
  id: number;
}

const createVacancyFormState = (vacancy: IVacancy | undefined, defaultRegion: IRegion): IVacancyFormState => ({
  byAgreementSalary: (vacancy && !vacancy.minSalary && !vacancy.maxSalary) || false,
  cancelAddVacancyModalOpened: false,
  contactEmail: (vacancy && vacancy.contactEmail) || '',
  contactPhone: '',
  contactsIsValid: true,
  description: (vacancy && decodeHtml(vacancy.description)) || '',
  descriptionIsValid: true,
  employment: (vacancy && vacancy.employment) || EEmployment.Full,
  formIsFilled: false,
  id: (vacancy && vacancy.id) || 0,
  maxSalary: vacancy && vacancy.maxSalary,
  minSalary: vacancy && vacancy.minSalary,
  noWorkExperience: (vacancy && !vacancy.workExperience) || false,
  recaptcha: '',
  recaptchaIsValid: true,
  region: (vacancy && vacancy.region) || defaultRegion,
  salaryIsValid: true,
  specialization: (vacancy && decodeHtml(vacancy.specialization)) || '',
  specializationIsValid: true,
  workExperience: vacancy && vacancy.workExperience,
  workExperienceIsValid: true,
});

export { createVacancyFormState, IVacancyFormState };
